"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var AddStudentModalInstanceCtrl = /** @class */ (function () {
    function AddStudentModalInstanceCtrl($scope, $rootScope, $stateParams, $uibModalInstance, drivesession, UsersModel, FlashService, toggleStudentSchoolOverride, $sce, preselectedSlot) {
        var _this = this;
        this.$scope = $scope;
        this.$sce = $sce;
        this.$uibModalInstance = $uibModalInstance;
        this.searchingStudents = false;
        this.toggleStudentSchoolOverride = toggleStudentSchoolOverride;
        this.drivesession = drivesession;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.student = null;
        this.studentsOnSession = [];
        this.students = [];
        this.observer_or_driver = "";
        // Pre-selected when launched from a specific open slot's "Add Student" button.
        this.selectedSlot = preselectedSlot || null;
        this.studentNotes = {
            currentPage: 0,
            page_by: 5,
            data: [],
            total: 0,
        };
        if (drivesession.hasOwnProperty("student") && drivesession.student) {
            this.studentsOnSession.push(drivesession.student);
        }
        if (this.drivesession.observation === true && !this.drivesession.students) {
            this.drivesession.students = [];
        }
        if (this.drivesession.hasOwnProperty("students") &&
            this.drivesession.students.length > 0) {
            this.drivesession.students.forEach(function (student) {
                _this.studentsOnSession.push(student);
            });
        }
        // An observation allows at most one driver, so only offer Driver when the
        // seat isn't already taken.
        var driverTaken = (this.drivesession.students || []).some(function (student) { return student.observer_or_driver === "driver"; });
        this.roleOptions = driverTaken
            ? [{ n: "Observer", v: "observer" }]
            : [
                { n: "Driver", v: "driver" },
                { n: "Observer", v: "observer" },
            ];
        $rootScope.$watch(function () { return _this.student; }, function (newValue, oldValue) {
            if (newValue) {
                _this.UsersModel.getStudentNotes(_this.student.id).then(function (response) {
                    _this.studentNotes.data = response.notes.data;
                    _this.studentNotes.total = response.notes.total;
                    _this.studentNotes.currentPage = response.notes.current_page;
                });
            }
        });
        this.addStudentToSession = this.addStudentToSession.bind(this);
        this.searchStudents = this.searchStudents.bind(this);
        this.studentNotesPageChanged = this.studentNotesPageChanged.bind(this);
    }
    /**
     * Search for students by name
     * @param search
     * @param all
     */
    AddStudentModalInstanceCtrl.prototype.searchStudents = function (search, all) {
        var _this = this;
        if (this.searchingStudents === true) {
            return;
        }
        var searchParams = {};
        this.searchingStudents = false;
        this.FlashService.clearFlash();
        var session_length = 0;
        // calculate the duration of this appointment
        if (!this.drivesession.session_length) {
            session_length =
                parseInt(this.drivesession.sessionLengthHours, 10) * 60 +
                    parseInt(this.drivesession.sessionLengthMinutes, 10);
        }
        else {
            session_length = this.drivesession.session_length;
        }
        var driveDate;
        if (this.drivesession.drive_date instanceof Date) {
            driveDate = this.drivesession.drive_date;
        }
        else {
            driveDate = this.drivesession.drive_date;
        }
        var driveTime;
        if (this.drivesession.start_time instanceof Date) {
            driveTime = this.drivesession.start_time;
        }
        else {
            driveTime = (0, time_1.timeStringToDate)(this.drivesession.start_time);
        }
        if (all === false) {
            searchParams = {
                hours: session_length,
                date: {
                    date: (0, time_1.formatDateTime)(driveDate, "YYYY-MM-DD"),
                    time: (0, time_1.formatDateTime)(driveTime, "HH:mm:ss"),
                    duration: session_length,
                },
            };
        }
        if (search && search.length >= 3 && !this.searchingStudents) {
            searchParams.name = search;
        }
        // searchParams.drive = this.drivesession;
        searchParams.exclude = {
            drives: [{ id: this.drivesession.id }],
        };
        if (typeof searchParams.name === "undefined") {
            return;
        }
        searchParams.toggleStudentSchoolOverride = this.toggleStudentSchoolOverride;
        this.searchingStudents = true;
        this.UsersModel.searchStudents(searchParams).then(function (response) {
            _this.students = response.students.map(function (student) {
                return student;
            });
            _this.searchingStudents = false;
        });
    };
    AddStudentModalInstanceCtrl.prototype.addStudentToSession = function () {
        var _this = this;
        this.FlashService.clearFlash();
        // prevent from adding if student is already on session
        var sessionHasStudent = this.studentsOnSession.filter(function (student) { return student.id === _this.student.id; });
        if (sessionHasStudent.length > 0) {
            return false;
        }
        // Is this drive session an observation?
        // If it is not, then just add the student
        if (this.drivesession.observation === false) {
            var student = Object.assign({}, this.student);
            student.saved = false;
            this.drivesession.student = student;
            this.drivesession.status = "Taken";
            this.drivesession.pickuplocation =
                this.drivesession.student.pickuplocations[0];
            this.drivesession.dropofflocation =
                this.drivesession.student.pickuplocations[0];
        }
        else {
            // Observation students claim one of the school's pre-defined open slots
            // rather than getting a free-form window.
            if (!this.selectedSlot) {
                this.FlashService.setMessage({
                    type: "warning",
                    message: "Please select a time slot for this student.",
                });
                return false;
            }
            var student = Object.assign({}, this.student);
            student.saved = false;
            student.observer_or_driver = this.observer_or_driver;
            student.slotId = this.selectedSlot.id;
            student.windowStart = this.selectedSlot.windowStart;
            student.windowEnd = this.selectedSlot.windowEnd;
            student.windowAdjusted = false;
            this.drivesession.students.push(student);
            // The claimed slot is no longer open for booking.
            var slotIndex = this.drivesession.openSlots.indexOf(this.selectedSlot);
            if (slotIndex > -1) {
                this.drivesession.openSlots.splice(slotIndex, 1);
            }
            this.drivesession.status = "Taken";
        }
        return true;
    };
    AddStudentModalInstanceCtrl.prototype.ok = function () {
        var addStudent = this.addStudentToSession();
        if (addStudent === true) {
            this.$uibModalInstance.close({
                drivesession: this.drivesession,
                toggleStudentSchoolOverride: this.toggleStudentSchoolOverride,
            });
        }
        else {
            this.FlashService.setMessage({
                type: "warning",
                message: "This student has already been booked with this session",
            });
        }
    };
    AddStudentModalInstanceCtrl.prototype.cancel = function () {
        this.$uibModalInstance.dismiss("cancel");
    };
    /// notes
    AddStudentModalInstanceCtrl.prototype.formatNoteContent = function (note) {
        return this.$sce.trustAsHtml(note);
    };
    AddStudentModalInstanceCtrl.prototype.deleteNote = function (index, note) {
        var _this = this;
        if (note.id) {
            this.submitting = true;
            this.UsersModel.removeStudentNote(this.student.id, note.id)
                .then(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.studentNotes.data = _this.studentNotes.data.filter(function (n) {
                    return note.id !== n.id;
                });
                _this.submitting = false;
            })
                .catch(function (Error) {
                _this.submitting = false;
            });
        }
        else {
            this.studentNotes.data.splice(index, 1);
        }
    };
    AddStudentModalInstanceCtrl.prototype.getRole = function (role) {
        if (role === 1) {
            return "Students";
        }
        if (role === 3) {
            return "Instructors";
        }
        if (role === 4) {
            return "Owners";
        }
        if (role === 5) {
            return "Administrators";
        }
        if (role === 9) {
            return "Staff";
        }
        return "Owner";
    };
    AddStudentModalInstanceCtrl.prototype.studentNotesPageChanged = function () {
        var _this = this;
        this.submitting = true;
        this.UsersModel.getStudentNotes(this.student.id, {
            page: this.studentNotes.currentPage,
        })
            .then(function (response) {
            _this.studentNotes.data = response.notes.data;
            _this.studentNotes.total = response.notes.total;
            _this.studentNotes.currentPage = response.notes.current_page;
            _this.submitting = false;
        })
            .catch(function (Error) {
            _this.submitting = false;
        });
    };
    return AddStudentModalInstanceCtrl;
}());
AddStudentModalInstanceCtrl.$inject = [
    "$scope",
    "$rootScope",
    "$stateParams",
    "$uibModalInstance",
    "drivesession",
    "UsersModel",
    "FlashService",
    "toggleStudentSchoolOverride",
    "$sce",
    "preselectedSlot",
];
exports.default = AddStudentModalInstanceCtrl;
